import moment from "moment";

const EMR_EDIT_LOCK_DAYS = 14;

export const canEditEmr = (visitData, isDoctor, fromEmr = false) => {
  if (!isDoctor) return true;
  const emr = fromEmr ? visitData : visitData?.emr;
  if (emr?.complete_check) return false;
  if (
    emr?.created_at &&
    moment().diff(moment(emr.created_at), "days") >= EMR_EDIT_LOCK_DAYS
  ) {
    return false;
  }
  return true;
};
